import { transactionTypes, type TransactionType } from "./utils";

/**
 *
 */
export type SamplingEnvConfig = {
  "page-load": { [pagecluster: string]: number[] | undefined };
  "http-request": { [pagecluster: string]: number | undefined };
};

/*                                  */
/**
 *
 *
 */
const pageLoadLive = {
"AftersalesOrders":[	1.000,	1.000,	0.734,	0.336,	0.195,	0.164,	0.113,	0.119,	0.084,	0.078,	0.075,	0.074,	0.078,	0.073,	0.072,	0.082,	0.093,	0.086,	0.089,	0.098,	0.115,	0.178,	0.327,	0.598	],
"Artikeldetailseite":[	0.038,	0.045,	0.046,	0.028,	0.018,	0.016,	0.012,	0.014,	0.010,	0.008,	0.008,	0.008,	0.008,	0.007,	0.007,	0.007,	0.007,	0.006,	0.005,	0.005,	0.005,	0.007,	0.014,	0.025	],
"BBS":[	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	0.833,	0.854,	0.622,	0.491,	0.462,	0.472,	0.499,	0.463,	0.441,	0.466,	0.486,	0.404,	0.367,	0.369,	0.409,	0.596,	1.000,	1	],
"Checkout":[	1.000,	1.000,	1.000,	1.000,	0.682,	0.543,	0.381,	0.397,	0.279,	0.220,	0.209,	0.212,	0.221,	0.205,	0.200,	0.207,	0.216,	0.182,	0.167,	0.163,	0.179,	0.242,	0.458,	0.885	],
"ConnectContact":[	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	0.783,	0.817,	0.584,	0.500,	0.479,	0.464,	0.486,	0.494,	0.471,	0.534,	0.625,	0.643,	0.718,	0.842,	0.926,	1.000,	1.000,	1	],
"Einstiegsseite":[	0.662,	0.656,	0.638,	0.549,	0.448,	0.439,	0.367,	0.389,	0.318,	0.260,	0.247,	0.230,	0.245,	0.191,	0.213,	0.257,	0.238,	0.273,	0.280,	0.284,	0.284,	0.390,	0.679,	0.799	],
"Errorseite404":[	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	0.865,	0.556,	0.575,	0.673,	0.996,	0.873,	1.000,	1.000,	1.000,	0.806,	0.852,	0.910,	0.909,	1.000,	1.000,	1	],
"Kundenbewertungsseite":[	1.000,	1.000,	1.000,	1.000,	0.893,	0.754,	0.553,	0.622,	0.449,	0.388,	0.375,	0.327,	0.349,	0.325,	0.318,	0.344,	0.355,	0.264,	0.230,	0.221,	0.219,	0.313,	0.612,	1	],
"Login":[	1.000,	1.000,	1.000,	0.569,	0.310,	0.233,	0.166,	0.175,	0.131,	0.120,	0.114,	0.112,	0.114,	0.112,	0.111,	0.121,	0.137,	0.121,	0.114,	0.122,	0.140,	0.216,	0.436,	0.843	],
"MYA_CustomerInbox":[	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	0.992,	1.000,	0.764,	0.609,	0.637,	0.628,	0.720,	0.690,	0.716,	0.819,	0.917,	0.941,	0.980,	1.000,	1.000,	1.000,	1.000,	1	],
"MYA_Dashboard":[	0.777,	0.864,	0.518,	0.252,	0.159,	0.152,	0.113,	0.126,	0.095,	0.077,	0.077,	0.078,	0.083,	0.080,	0.079,	0.089,	0.087,	0.085,	0.085,	0.091,	0.103,	0.154,	0.261,	0.482	],
"MYA_Invoices":[	1.000,	1.000,	0.659,	0.319,	0.192,	0.180,	0.140,	0.156,	0.123,	0.107,	0.107,	0.110,	0.116,	0.111,	0.108,	0.123,	0.126,	0.118,	0.121,	0.132,	0.147,	0.216,	0.376,	0.662	],
"MYA_Orders":[	0.873,	0.926,	0.566,	0.250,	0.149,	0.130,	0.087,	0.091,	0.066,	0.061,	0.060,	0.060,	0.062,	0.059,	0.058,	0.067,	0.075,	0.070,	0.072,	0.080,	0.094,	0.148,	0.273,	0.525	],
"MYA_UP":[	1.000,	1.000,	1.000,	1.000,	0.808,	0.821,	0.731,	0.904,	0.691,	0.470,	0.513,	0.612,	0.633,	0.616,	0.606,	0.644,	0.555,	0.550,	0.543,	0.567,	0.604,	0.918,	1.000,	1	],
"OM_Returns":[	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	0.874,	0.863,	0.812,	0.762,	0.693,	0.635,	0.702,	0.853,	0.765,	0.804,	0.945,	1.000,	1.000,	1.000,	1	],
"Payment-Selection-FD-ViewPaymentSelection":[	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	1.000,	0.950,	0.764,	0.701,	0.710,	0.738,	0.672,	0.676,	0.672,	0.696,	0.619,	0.563,	0.534,	0.574,	0.723,	1.000,	1	],
"Paymentinfo":[	1.000,	1.000,	1.000,	0.492,	0.285,	0.255,	0.193,	0.213,	0.164,	0.145,	0.144,	0.148,	0.150,	0.146,	0.141,	0.159,	0.173,	0.159,	0.163,	0.178,	0.199,	0.294,	0.543,	0.919	],
"Produktliste":[	0.225,	0.256,	0.247,	0.163,	0.123,	0.113,	0.086,	0.096,	0.072,	0.060,	0.059,	0.056,	0.059,	0.054,	0.053,	0.055,	0.040,	0.041,	0.038,	0.038,	0.038,	0.056,	0.107,	0.164	],
"Storefront":[	0.203,	0.219,	0.180,	0.103,	0.070,	0.070,	0.056,	0.061,	0.046,	0.036,	0.035,	0.035,	0.038,	0.035,	0.034,	0.037,	0.034,	0.030,	0.028,	0.029,	0.031,	0.045,	0.079,	0.14	],
"Suchergebnisseite":[	0.113,	0.158,	0.156,	0.094,	0.059,	0.053,	0.038,	0.041,	0.029,	0.024,	0.022,	0.021,	0.021,	0.019,	0.018,	0.019,	0.019,	0.016,	0.014,	0.013,	0.014,	0.020,	0.038,	0.069	],
"Warenkorb":[	0.453,	0.616,	0.508,	0.271,	0.161,	0.142,	0.105,	0.110,	0.082,	0.064,	0.061,	0.062,	0.065,	0.062,	0.058,	0.062,	0.056,	0.045,	0.040,	0.039,	0.046,	0.066,	0.131,	0.258	],
"Wishlist":[	0.803,	1.000,	0.872,	0.433,	0.259,	0.242,	0.188,	0.202,	0.149,	0.114,	0.114,	0.113,	0.120,	0.111,	0.103,	0.110,	0.100,	0.090,	0.082,	0.081,	0.087,	0.125,	0.233,	0.466	],
"test":[	1.000,	1.000,	1.000,	1.000,	1.000,	0.951,	0.730,	0.781,	0.560,	0.414,	0.393,	0.397,	0.405,	0.378,	0.352,	0.375,	0.351,	0.296,	0.259,	0.255,	0.256,	0.354,	0.653,	1	],
};
/*                                 */

/**
 *
 *
 *
 */
const liveHttpRequest = {
  Artikeldetailseite: 0.15,
  Einstiegsseite: 0.25,
  Errorseite404: 0.5,
  Login: 0.7, /*  */
  Registration: 0.15,
  Produktliste: 0.08,
  Storefront: 0.2,
  Suchergebnisseite: 0.07,
  VirtualAgentAftersales: 0.13,
  Warenkorb: 0.4,
  OM_Returns: 0.7,
};

/**
 *
 *
 */
export const sampligRates: Record<"live" | "develop", SamplingEnvConfig> = {
  live: {
    [transactionTypes[0]]: pageLoadLive,
    [transactionTypes[1]]: liveHttpRequest,
  },
  develop: { [transactionTypes[0]]: {}, [transactionTypes[1]]: {} },
};

export const getSamplingRate = (
  type: TransactionType,
  pagecluster: string,
  now = new Date(),
  env = import.meta.env.VITE_OTTO_INSTALLATION_ENV,
): number => {
  const current = now.getUTCHours(); /*          */
  const rates = sampligRates[env];

  if (type === "page-load") {
    const { [pagecluster]: pcRates = [] } = rates[type];
    return pcRates[current] ?? 1;
  }

  return rates[type][pagecluster] ?? 1;
};
